import packageOffersHotels from './packageOffersHotels.json';
import packageDetails from  './packageOffersDetails.json';
import packageSections from  './packageOffersSections.json';

export default {
    packageDetails: packageDetails,
    packageSections: packageSections,
    packageHotels: packageOffersHotels
};
